module.exports = __webpack_public_path__ + "img/toolbar_zhaq.7b655c21.png";